//Mixin des comportement mimic du nouveau mode fiche (iris)
import { en, fr } from '../i18n';

let globalInit = false;

export const ednLang = {
  created() {
    if (!globalInit) {
      this.initLang();
      globalInit = true;
    }
  },
  methods: {
    /**
     * Initialise les langues : on récupère les traductions par défaut
     * Elles seront ensuite écrasées si besoin pas l'application qui appelera l'eudofront
     * Par défaut, on initialise les composants en français
     */
    initLang(){
      let aLang = [{val:'en',obj:en},{val:'fr',obj:fr}];
      aLang.forEach(lang => {
        this.$vuetify.lang.locales[lang.val] = {...lang.obj,...this.$vuetify.lang.locales[lang.val]}
        this.$vuetify.lang.locales[lang.val].invalidMsg = {...lang.obj.invalidMsg ,...this.$vuetify.lang.locales[lang.val].invalidMsg }
        this.$vuetify.lang.locales[lang.val].placeHolder = {...lang.obj.placeHolder ,...this.$vuetify.lang.locales[lang.val].placeHolder }
        this.$vuetify.lang.locales[lang.val].image = {...lang.obj.image ,...this.$vuetify.lang.locales[lang.val].image }
      })
      this.$vuetify.lang.locales.fr = {...this.$vuetify.lang.locales.en,...this.$vuetify.lang.locales.fr }
    }
  },
}
